export default {
  namespaced: true,

  state: {
    items: []
  },

  mutations: {
    set(state, items) {
      state.items = items;
    },
    add(state, item) {
      state.items.push(item);
    },
    update(state, company) {
      let index = state.items.findIndex(item => {
        return company.identifier === item.identifier;
      });

      state.items[index] = company;
    },
    retrieve(state) {
      if (!state.items.length) {
        window.Ajax.get('/companies')
          .then(response => {
            state.items = response.data;
          })
          .catch(err => {});
      }
    }
  },

  getters: {
    all(state) {
      return state.items;
    },

    referrers(state) {
      return state.items.filter(item =>
        item.types.map(type => type.name).includes('referrer')
      );
    },

    solicitors(state) {
      return state.items.filter(item =>
        item.types.map(type => type.name).includes('solicitor')
      );
    },

    engineers(state) {
      return state.items.filter(item =>
        item.types.map(type => type.name).includes('engineer')
      );
    },

    issuingAuthorities(state) {
      return state.items.filter(item =>
        item.types.map(type => type.name).includes('issuing_authorities')
      );
    }
  }
};
